import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/app/(reporter)/reporter/components/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourismClientTab"] */ "/app/app/(tourism)/tourism/components/TourismClientTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourismHero"] */ "/app/app/(tourism)/tourism/components/TourismHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourismNav"] */ "/app/app/(tourism)/tourism/components/TourismNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/banner/YandexRtbAd.tsx");
